import { MyProfileData } from 'cpfr-common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { fetchMyProfile } from './MyProfileSlice';
import { MyProfileDataSelector } from './MyProfileDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

export function useMyProfile(notFetch?: boolean): AbstractDataState<MyProfileData, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchMyProfile, MyProfileDataSelector, undefined, undefined, undefined, !notFetch);
}
